export default {
  SPIN: 'SPIELEN',
  'You are not eligible for free spins':
    'Nur Steam-Kontos mit CSGO-Spiel und ohne VAC sind zu kostenlosen Münzen berechtigt. Loggen Sie sich erneut auf der Seite ein, um zu aktualisieren.',
  'It must be 24 hours since last roll':
    'Es müssen 24 Stunden seit dem letzten Wurf vergangen sein.',
};
